<template>
    <Teleport to="body">
        
        <div v-if="isVisible" class="modal-overlay">
            
            <div class="editor-popup">
                <span style="font-size: smaller; text-align: center;">Após finalizar a edição, utilize o ícone <img :src='BASE_URL+"imagens/icons/adobe-pdf-icone.png"' width="15px" /> para salvar e escolher o tipo de documento.</span>
                <br />
                <a @click="saveDocument" style="cursor: pointer;"><img :src='BASE_URL+"imagens/icons/adobe-pdf-icone.png"' width="30px" /></a>
                <br />
                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>

                <div style="text-align: right;">
                    <div class="row">
                        <div class="col-12" style="text-align: right;">
                            <button @click="cancel" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer;">
                                <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Cancelar</label>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </Teleport>
</template>
  
<script>
  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  
  export default {
    components: {
      ckeditor: CKEditor.component
    },
    data() {
      return {
        BASE_URL: window.Laravel.baseUrl,
				editor: ClassicEditor,
				editorData: '',
				editorConfig: {
					// Configurações do CKEditor
					placeholder: 'Digite a petição aqui...',
					language: 'pt-br',
				},
				isVisible: false,
			};
		},
		methods: {
			// #region Métodos para integração com IA
			retornaDadosParaIA() {
				return {
					conteudo_editor: this.editorData || '',
					uploadedFiles: []
				};
			},
			// #endregion

			saveDocument() {
				let processoId = this.$store.state.processo.id;
				let data = {
					processoId: processoId,
					editorData: this.editorData
				};

				axios.post(this.BASE_URL + 'upload-documento-digitado', data)
					.then(response => {

						//Só salva o arquivo e coloca ele no anexo de forma temporária pois a petição é criada no outro componente.

						this.$store.commit('setDocumentPathTemporario', response.data.path);

						this.isVisible = false; // Feche o popup após salvar
					})
					.catch(error => {
						console.error('Erro gravar documento PDF:', error);
					});

			},
			openEditor() {
				this.isVisible = true;
			},
			cancel() {
				this.isVisible = false; // Simplesmente fecha o popup sem salvar
			}
		}
	}
</script>

<style>

/* Fundo escuro que cobre TODA a tela */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Preto 50% transparente */
    z-index: 9999999; /* Garante que fique na frente de tudo */
    
    /* Centraliza o conteúdo (o popup) */
    display: flex;
    justify-content: center;
    align-items: center;
}

.editor-popup {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
    
    /* Tamanho do seu editor */
    height: 570px;
    width: 80%;
    max-width: 900px;

    /* Não precisa mais de position fixed aqui dentro */
}

	.ck-editor__editable {
		min-height: 400px !important;
		/* Ajuste conforme necessário */
	}

	.ck-editor__editable_inline {
		min-height: 400px !important;
	}

	.ck.ck-editor {
		min-width: 400px !important;
	}

	.ck-content {
		height: 400px !important;
	}
</style>
